import React, { useEffect, useState } from "react";
import "./RCList.css";

const RCList = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    fetchList();
  }, []);

  const fetchList = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `https://rcfinder.online/api/getrc_list.php?user_id=${user.id}`
      );
      const data = await res.json();

      if (data.status) {
        setList(data.data);
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Server Error");
    }
    setLoading(false);
  };

  // ✅ FIXED DOWNLOAD (BLOB METHOD 🔥)
  const handleDownload = (base64, rcno) => {
    try {
      if (!base64) {
        alert("Invalid PDF data");
        return;
      }

      // Remove prefix if present
      base64 = base64.replace(/^data:application\/pdf;base64,/, "");

      // Convert base64 to binary
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      // Create blob
      const blob = new Blob([byteArray], { type: "application/pdf" });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = `${rcno}.pdf`;
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      alert("Download failed");
    }
  };

  return (
    <div className="rc-list-container">
      <div className="header">
        <h2>RC List</h2>
        <button onClick={fetchList}>Refresh</button>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>RC Number</th>
              <th>Application No</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {list.length > 0 ? (
              list.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.rc_number}</td>
                  <td>{item.application_no}</td>
                  <td>{item.created_at}</td>
                  <td>
                    <button
                      onClick={() =>
                        handleDownload(item.pdf_base64, item.rc_number)
                      }
                    >
                      Download PDF
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No Data Found</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default RCList;